import { sendApiRequest } from '##/services/tenApi/apirequest';
import { config } from '##/services/store/store';
import { sendErrorToTealium } from '##/components/Error';
import {
  TealiumErrorCode,
  TealiumErrorContext,
} from '##/services/analytics/Tealium/TealiumErrorTypes';

import { HomePageResponse, MyShowsResponse } from './types';

export const getHomePage = async (): Promise<HomePageResponse> => {
  const regionId = config.$get().geo.region;
  const { homePageApiEndpoint } = config.$get().app;

  return sendApiRequest<HomePageResponse>(`${homePageApiEndpoint}/${regionId}`);
};

export const getMyShowData = async (): Promise<MyShowsResponse> => {
  const { favouriteApiEndpoint } = config.$get().app.userEndpoints;
  try {
    return await sendApiRequest<MyShowsResponse>(
      `${favouriteApiEndpoint}/shows`,
    );
  } catch (err) {
    sendErrorToTealium({
      errorCode: TealiumErrorCode.FetchMyShow,
      errorContext: TealiumErrorContext.API,
      errorDetail: JSON.stringify(err),
      errorSource: favouriteApiEndpoint,
      errorMessage: '',
    });
    throw err;
  }
};

export const postMyShow = async (
  showId: string,
  isShowSaved: boolean,
): Promise<void> => {
  const { favouriteApiEndpoint } = config.$get().app.userEndpoints;
  try {
    return await sendApiRequest(
      `${favouriteApiEndpoint}/shows/${showId}`,
      isShowSaved ? 'DELETE' : 'POST',
      {},
      { type: 'show' },
    );
  } catch (err) {
    sendErrorToTealium({
      errorCode: TealiumErrorCode.PostMyShow,
      errorContext: TealiumErrorContext.API,
      errorDetail: JSON.stringify(err),
      errorSource: favouriteApiEndpoint,
      errorMessage: '',
    });
    throw err;
  }
};
